// Chat widget (Social Intents). Disabled in gov (cl04), same gate as New Relic.

(function() {
  var isGov = window.location.hostname.split('.')[1] === 'cl04';

  function ngNotify(method, title, description) {
    var injector = window.angular && window.angular.element(document.getElementById('ng-app')).injector();
    if (!injector) return;
    // $evalAsync is safe from both inside and outside the digest cycle.
    injector.get('$rootScope').$evalAsync(function() {
      injector.get('NotificationService')[method]({ title: title, description: description });
    });
  }

  if (isGov) {
    window.showChat = function() {
      ngNotify('addInfo', 'Chat Unavailable',
        'Live chat is not available. Please contact ' +
        '<a href="mailto:folio_support@innovativedriven.com">folio_support@innovativedriven.com</a> for assistance.');
    };
    return;
  }

  // Opened only via showChat(), so hide the floating tab.
  window.onSIApiReady = function() {
    window.SI_API.hideTab();
  };

  var script = document.createElement('script');
  script.src = 'https://www.socialintents.com/api/chat/socialintents.1.5.js#2c9fa8e7a0556d3201a05daaf47b0c90';
  script.async = true;
  document.body.appendChild(script);

  window.showChat = function() {
    if (window.SI_API) {
      window.SI_API.showPopup();
      return;
    }
    ngNotify('addError', 'Chat Unavailable',
      'The chat widget failed to load. Please clear your cache and reload the page ' +
      '(ctrl/cmd + shift + r in Chrome) to try again, or <a href="mailto:folio_support@innovativedriven.com">contact support</a> ' +
      'if the issue persists.');
  };
})();
